
namespace RecordShield.Workspace {
    
    @Serenity.Decorators.registerClass()
    export class ActivationHistoryGrid extends Serenity.EntityGrid<ActivationHistoryRow, any> {
        protected getColumnsKey() { return 'Workspace.ActivationHistory'; }
        protected getDialogType() { return ActivationHistoryDialog; }
        protected getIdProperty() { return ActivationHistoryRow.idProperty; }
        protected getLocalTextPrefix() { return ActivationHistoryRow.localTextPrefix; }
        protected getService() { return ActivationHistoryService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getQuickFilters() {
            debugger;
            var filters = super.getQuickFilters();
            
            if (!Authorization.hasPermission("Administration:Security")) {
                filters.splice(Q.indexOf(filters, x => x.field == "ProductTenantId"), 1);
                filters.splice(Q.indexOf(filters, x => x.field == "ProductId"), 1);
            }
            else
            {
                filters.splice(Q.indexOf(filters, x => x.title == "Product Name"), 1);
            }
            return filters;
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/ActivationHistory/ListExcel',
                separator: true
            }));
            buttons.push(RecordShield.Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));
            return buttons;
        }
    }
}